const thumbnailUrl = (
  url: string,
  { size }: { size: 300 | 600 | 1200 } = { size: 300 }
) => {
  const path = url
    .replace("https://griptonite-media.s3.amazonaws.com/", "")
    .replace("https://media.griptonite.io/", "");
  const parts = path.split("/");
  const prefix = parts[0];
  const stemPath = parts.slice(1).join("/").split(".")[0];

  return `https://media-processed.griptonite.io/${prefix}/crop/${size}x${size}/${stemPath}.jpg`;
};

export default thumbnailUrl;
